import { BreadthRebateProgramResult } from "@dana/Services/BreadthRebateProgramService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface BreadthRebateProgramState {
    isLoading: boolean;
    data?: BreadthRebateProgramResult;
    error: string | null;
}

const initialState: BreadthRebateProgramState = {
    isLoading: false,
    data: undefined,
    error: null,
};

const breadthRebateProgramReducer = createTypedReducerWithImmer(initialState, {
    "BreadthRebateProgram/IsLoading": (draft: Draft<BreadthRebateProgramState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null;
        }
    },

    "BreadthRebateProgram/PopulateResult": (
        draft: Draft<BreadthRebateProgramState>,
        action: { data: BreadthRebateProgramResult },
    ) => {
        draft.data = action.data;
        draft.isLoading = false;
        draft.error = null;
    },

    "BreadthRebateProgram/FetchError": (draft: Draft<BreadthRebateProgramState>, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    "BreadthRebateProgram/Reset": () => initialState,
});

(reducers as any).breadthRebateProgram = breadthRebateProgramReducer;

type BreadthRebateProgramReducers = {
    breadthRebateProgram: typeof breadthRebateProgramReducer;
};

export type BreadthRebateProgramActions =
    | Parameters<BreadthRebateProgramReducers[keyof BreadthRebateProgramReducers]>[1]
    | AnyAction;
